<template>
  <div class="team-main">
    <HeadContent
      :title="modalTit"
      routename="configIndex"
      :subtitle-first="headTit"
      :subtitle-second="modalTit"
    />
    <div class="content-box">
      <div class="content-child">
        <t-list />
      </div>
      <div class="content-child">
        <i-content v-if="inviteNewMemberVisible" />
        <t-content v-else />
      </div>
    </div>
    <member-dialog />
    <add-member-dialog />
    <add-group-dialog />
    <team-set-drawer />
    <group-set-drawer />
    <a-spin
      v-if="loadingVision"
      class="loading-spin"
    />
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import HeadContent from '@/components/pc/HeadContent'
import TList from './TList'
import TContent from './TContent'
import IContent from './IContent'
import MemberDialog from './MemberDialog'
import AddMemberDialog from './AddMemberDialog'
import AddGroupDialog from './AddGroupDialog'
import TeamSetDrawer from './TeamSetting'
import GroupSetDrawer from './GroupSetting'
export default {
  components: {
    TList,
    TContent,
    IContent,
    MemberDialog,
    AddMemberDialog,
    AddGroupDialog,
    TeamSetDrawer,
    GroupSetDrawer,
    HeadContent
  },
  data () {
    return {}
  },
  computed: {
    ...mapState('team/manage', ['inviteNewMemberVisible', 'loadingVision']),
    modalTit () {
      return this.$t('message["1228"]')
    },
    headTit () {
      return this.$t('message["1326"]')
    }
  },
  created () {
    this.fetchTeamOrganizationDatas()
  },
  mounted () {
    this.setInviteMemberVisible(false)
  },
  methods: {
    ...mapMutations('team/manage', ['setInviteMemberVisible']),
    ...mapActions('team/manage', ['fetchTeamOrganizationDatas'])
  }
}
</script>
<style lang="scss" scoped>
.loading-spin {
  position: absolute;
  top: 50%;
  left: 50%;
}
.team-main {
  width: 1040px;
  margin: 0 auto;
  .content-box {
    height: 728px;
    width: 100%;
    display: table;
    border-radius: 4px;
    margin-bottom: 40px;
    .content-child {
      display: table-cell;
      &:first-child {
        width: 248px;
        overflow: hidden !important;
        background-color: #f5f6f7;
        border-radius: 4px;
      }
    }
  }
}
</style>
